/**
 * Mobile sticky ATC — sync price on variant change, submit main buy form.
 */
(function () {
  const bar = document.querySelector('[data-pi-sticky-atc]');
  if (!bar) return;

  const mq = window.matchMedia('(max-width: 989px)');

  function setVisible() {
    if (mq.matches) bar.removeAttribute('hidden');
    else bar.setAttribute('hidden', 'hidden');
  }

  setVisible();
  mq.addEventListener('change', setVisible);

  const priceEl = bar.querySelector('[data-pi-sticky-price]');
  const submitBtn = bar.querySelector('[data-pi-sticky-submit]');

  document.addEventListener('pi:variant-change', (e) => {
    const variant = e.detail?.variant;
    if (!variant || !priceEl) return;
    if (window.Shopify?.formatMoney) {
      priceEl.textContent = window.Shopify.formatMoney(variant.price);
    }
    bar.dataset.variantId = String(variant.id);
    if (submitBtn) submitBtn.disabled = !variant.available;
  });

  submitBtn?.addEventListener('click', () => {
    const formBtn = document.querySelector(
      '[data-pi-product-info] [type="submit"], pi-buy-form [type="submit"], .product-form__submit',
    );
    if (formBtn) formBtn.click();
  });
})();
